interface INoDataMessageProps {
  category: string;
  content: string;
}

const NoDataMessage = ({ content, category }: INoDataMessageProps) => {
  return (
    <div className="flex flex-col">
      <h3 className="text-[16px] uppercase tracking-wider dark:text-white">
        {category}
      </h3>

      <div className="flex flex-1 items-center justify-center">
        <p className="text-[14px] italic dark:text-white/60">{content}</p>
      </div>
    </div>
  );
};

export default NoDataMessage;
